import { render, staticRenderFns } from "./TableAuthorizerPending.vue?vue&type=template&id=b7a6532a&"
import script from "./TableAuthorizerPending.vue?vue&type=script&lang=ts&"
export * from "./TableAuthorizerPending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports